import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  type IPricingRule,
  type IPricingRuleItem,
  PricingRuleType,
} from '@principle-theorem/principle-core/interfaces';
import { TrackByFunctions } from '@principle-theorem/ng-shared';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'pr-service-pricing-rule-item-select',
  templateUrl: './service-pricing-rule-item-select.component.html',
  styleUrls: ['./service-pricing-rule-item-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ServicePricingRuleItemSelectComponent {
  pricingRule$ = new ReplaySubject<IPricingRule>(1);
  isVariable$: Observable<boolean>;
  selectedItemUid$: Observable<string | undefined>;
  trackByRuleItems = TrackByFunctions.uniqueId<IPricingRuleItem>();
  @Input() disabled = false;
  @Output() resetPrice = new EventEmitter<void>();
  @Output() updateSelectedRuleItem = new EventEmitter<IPricingRule>();

  @Input()
  set pricingRule(pricingRule: IPricingRule) {
    if (pricingRule) {
      this.pricingRule$.next(pricingRule);
    }
  }

  constructor() {
    this.isVariable$ = this.pricingRule$.pipe(
      map((pricingRule) => pricingRule.type === PricingRuleType.Variable)
    );

    this.selectedItemUid$ = this.pricingRule$.pipe(
      map(
        (pricingRule) =>
          pricingRule.ruleItems.find((item) => item.selected)?.uid
      )
    );
  }

  updateSelected(pricingRule: IPricingRule, ruleItemUid: string): void {
    this.updateSelectedRuleItem.next({
      ...pricingRule,
      ruleItems: pricingRule.ruleItems.map((ruleItem) => {
        if (ruleItem.uid !== ruleItemUid) {
          return {
            ...ruleItem,
            selected: false,
          };
        }

        return {
          ...ruleItem,
          selected: true,
        };
      }),
    });
  }

  shouldShowPricingRules(pricingRuleType: PricingRuleType): boolean {
    return [
      PricingRuleType.StairStep,
      PricingRuleType.Tiered,
      PricingRuleType.Variable,
    ].includes(pricingRuleType);
  }

  isAutoSelected(pricingRuleType: PricingRuleType): boolean {
    return pricingRuleType === PricingRuleType.Tiered;
  }
}
